import {
  COHORT_FIREBASE_KEYS_MAP,
  COHORT_GROWTHBOOK_KEYS_MAP,
  TAbTestKey,
} from 'nove8/constants/ab-tests'
import { Cohort } from 'nove8/constants/root-constants'

const toVariantRecord = (
  data: Record<string, string> | string | null | undefined,
  keys?: TAbTestKey | TAbTestKey[],
): Record<string, string> => {
  if (!data || !keys) return {}

  if (typeof data === 'string') {
    const key = Array.isArray(keys) ? keys[0] : keys
    return key ? { [key]: data } : {}
  }

  return data
}

export const mergeAbTestVariantData = ({
  cohort,
  firebaseRemoteConfigVariantData,
  growthbookVariantData,
}: {
  cohort: string
  firebaseRemoteConfigVariantData: Record<string, string> | string | null
  growthbookVariantData: Record<string, string> | string | null
}): Record<string, string> => ({
  ...toVariantRecord(
    firebaseRemoteConfigVariantData,
    COHORT_FIREBASE_KEYS_MAP[cohort as Cohort],
  ),
  ...toVariantRecord(
    growthbookVariantData,
    COHORT_GROWTHBOOK_KEYS_MAP[cohort as Cohort],
  ),
})
